import { APPLICATION_PAGE_ERROR, APPLICATION_PRODUCTS } from "./ApplicationPage.action";
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    products: [],
}
export const ApplicationPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case APPLICATION_PAGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        case APPLICATION_PRODUCTS:
            return {
                ...state,
                products: action.payload
            };
        default:
            return state;
    }
}